export default "__VITE_ASSET__C9MayIoH__"